<template>
    <div class="container">
        <div class="agreement" v-html="agreementData"></div>
        <div class="footer">
            <div class="checked_box">
                <van-checkbox icon-size="16" v-model="checked" checked-color="#FFB14A">我已阅读并同意</van-checkbox>
                <span class="tip" @click="checkNotice">《注销须知》</span>
            </div>
            <van-button type="info" round color="#FFB14A" block @click="clickAgreement">注销</van-button>
        </div>
    </div>
</template>
<script>
import { getActivityRuleContent } from "@/api/join";
export default {
    name:'buyerWriteOff',
    data(){
        return{
            agreementData:'',
            checked:false,
        }
    },
    created(){
        this._getRuleContent()
    },
    methods:{
        async _getRuleContent(){
            const res = await getActivityRuleContent({type:34})
            if(res.appStatus.errorCode == 0){
                this.agreementData = res.content.content;
            }else{
                this.$toast(res.appStatus.message);
            }
        },
        checkNotice(){
            this.$router.push({path:'/buyerCancellationNotice'})
        },
        clickAgreement(){
            if(!this.checked){
                return this.$toast('请先勾选我已阅读并同意注销须知')
            }
            this.$dialog.confirm({
                message: '确认后帐号将被立即注销，历史数据将被删除，同时手机号、第三方授权将被释放；再次登录将会创建一个新的帐号',
                confirmButtonText:'确认注销',
                confirmButtonColor:'#FF8D4B',
                cancelButtonText:'放弃',
                // theme: 'round-button',
            })
            .then(() => {
                this.$router.push({path:'/buyerLogout',query:this.$route.query})
            })
            .catch(() => {
                // on cancel
            });
        },
    }
}
</script>
<style lang="scss" scoped>
    .container{
        // height: 100%;
        height: calc(100vh - 46px);
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        .agreement{
            height: 100%;
            overflow-y: auto;
            flex: 1;
        }
        .footer{
            height: 74px;
            padding: 22px 0 20px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            .checked_box{
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                margin-bottom: 17px;
                .tip{
                    color: #4385DB;
                }
                /deep/.van-checkbox{
                    align-items: center;
                }
                /deep/.van-checkbox__label{
                    line-height: normal;
                }
            }
            /deep/.van-button{
                width: 345px;;
            }
        }
    }
</style>